import Lineup from 'actions/lineup';
import LineupResolver from 'actions/lineup-resolver';
import Stack from 'actions/stack';
import Modal from 'actions/modal';
import Router from 'actions/router';
import State from 'actions/state';
import Message from 'actions/message';
import TeamsCombinations from 'actions/teams-combinations';
import TeamsStacks from 'actions/teams-stacks';
import Storage from 'actions/storage';
import Player from 'actions/player';
import PlayersLock from 'actions/players-lock';
import PlayersExclusion from 'actions/players-exclusion';
import PlayersSympathy from 'actions/players-sympathy';
import PlayersPosition from 'actions/players-position';
import PointsBoundary from 'actions/points-boundary';
import SalaryBoundary from 'actions/salary-boundary';
import SalaryCap from 'actions/salary-cap';
import SportConfig from 'actions/sport-config';
import ModesConfig from 'actions/modes-config';
import Settings from 'actions/settings';
import Game from 'actions/game';
import Slate from 'actions/slate';
import OptimizationConfig from 'actions/optimization-config';
import PlayerSettingPopup from 'actions/player-setting-popup';
import ExposureMode from 'actions/exposure-mode';
import UniquePlayersQuantity from 'actions/unique-players-quantity';
import ProjectionPointsType from 'actions/projection-points-type';
import UserPointsType from 'actions/user-points-type';
import RangeOfOutcomes from 'actions/range-of-outcomes';
import LineupsQuantity from 'actions/lineups-quantity';
import Team from 'actions/team';
import ProjectedOwnershipCap from 'actions/projected-ownership-cap';
import Socket from 'actions/socket';
import FilterLineupsByPlayer from 'actions/filter-lineups-by-player';
import OpposingPlayers from 'actions/opposing-players';
import FilterLineupsByTeamCombinations from 'actions/filter-lineups-by-team-combinations';
import FilterLineupsByCorrelationStackCombinations from 'actions/filter-lineups-by-correlation-stack-combinations';
import FilterLineupsByKeyPlayerStackCombinations from 'actions/filter-lineups-by-key-player-stack-combinations';
import GeneratorType from 'actions/generator-type';
import ShowPlayersExposureWhileOptimized from 'actions/show-players-exposure-while-optimized';
import PrioritizeCompletingLineupsAboveExp from 'actions/prioritize-completing-lineups-above-exp';
import AvoidFewPassReceivers from 'actions/avoid-few-pass-receivers';
import PlayersDropzone from 'actions/players-dropzone';
import Theme from 'actions/theme';
import FlexMaxExposurePositions from 'actions/flex-max-exposure-positions';
import StackQuarterbackWithPassReceivers from 'actions/stack-quarterback-with-pass-receivers';
import UseOpposingGoalie from 'actions/use-opposing-goalie';
import LimitOnePitcherPerGame from 'actions/limit-one-pitcher-per-game';
import PlayerConfirmed from 'actions/player-confirmed';
import LineGroups from 'actions/line-groups';
import HittersOrder from 'actions/hitters-order';
import AllowOnlyOneKPositionPerLineup from 'actions/allow-only-one-K-position-per-lineup';
import AllowOnlyOneDSTPositionPerLineup from 'actions/allow-only-one-DST-position-per-lineup';

const BaseAction = {
    do(method, ...args) {
        try {
            return this[method](...args);
        } catch (e) {
            console.error('ACTION ERR: ', e);
        }
    },
    get(method, ...args) {
        return this.do('get' + method, ...args);
    },
    set(method, ...args) {
        return this.do('set' + method, ...args);
    },
};

let Action = Object.assign(
    Router,
    Lineup,
    LineupResolver,
    TeamsCombinations,
    TeamsStacks,
    Stack,
    Modal,
    State,
    Message,
    Storage,
    Player,
    PlayersLock,
    PlayersExclusion,
    PlayersSympathy,
    PlayersPosition,
    PointsBoundary,
    SalaryBoundary,
    SalaryCap,
    SportConfig,
    ModesConfig,
    Settings,
    Game,
    Slate,
    OptimizationConfig,
    PlayerSettingPopup,
    ExposureMode,
    UniquePlayersQuantity,
    ProjectionPointsType,
    UserPointsType,
    RangeOfOutcomes,
    LineupsQuantity,
    Team,
    ProjectedOwnershipCap,
    Socket,
    FilterLineupsByPlayer,
    OpposingPlayers,
    FilterLineupsByTeamCombinations,
    FilterLineupsByCorrelationStackCombinations,
    FilterLineupsByKeyPlayerStackCombinations,
    PlayersDropzone,
    Theme,
    GeneratorType,
    ShowPlayersExposureWhileOptimized,
    PrioritizeCompletingLineupsAboveExp,
    AvoidFewPassReceivers,
    FlexMaxExposurePositions,
    StackQuarterbackWithPassReceivers,
    UseOpposingGoalie,
    LimitOnePitcherPerGame,
    AllowOnlyOneKPositionPerLineup,
    AllowOnlyOneDSTPositionPerLineup,
    PlayerConfirmed,
    LineGroups,
    HittersOrder,
);

// To prevent extending BaseAction avoid adding it to Object.assign
Action = {...BaseAction, ...Action};

export {BaseAction};
export default Action;
